<div class="modal-header">
    <h4 class="modal-title">Send Confirmation</h4>
</div>
<div *ngIf="true" class="modal-body">
    <div style="margin-bottom: 5px">
        <strong>Proposal: {{ proposal?.description }}</strong>
    </div>

    <div class="d-flex" style="margin-top: 15px">
        <div>
            <label class="mt-2 me-2">Type</label>
        </div>
        <div>
            <dx-select-box
                [(value)]="selectedCommitteeId"
                [items]="types"
                [valueExpr]="'id'"
                [displayExpr]="'name'"
                (onSelectionChanged)="selectionChanged($event)"
            ></dx-select-box>
        </div>
    </div>
    <div class="d-flex" style="margin-top: 15px">
        <div>
            <label class="mt-2 me-2">Message</label>
        </div>
        <div>
            <dx-select-box
                [(value)]="selectedMessage"
                [displayExpr]="'name'"
                [items]="messages"
            ></dx-select-box>
        </div>
    </div>
    <div class="d-flex flex-fill flex-column" style="margin-top: 15px">
        <div>
            <label class="mt-2 me-2">Selected Message</label>
        </div>
        <div *ngIf="selectedMessage">
            <dx-text-area
                [(value)]="selectedMessage.message"
                height="150px"
                [readOnly]="true"
            ></dx-text-area>
        </div>
    </div>
    <div class="d-flex justify-content-end">
        {{ !!dealers ? dealers.length + ' dealers selected' : '' }}
    </div>

    <div *ngIf="dealers" class="widget-content user">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Dealer</th>
                    <th>Email</th>
                </tr>
            </thead>
            <tbody>
                <tr [hidden]="dealers.length > 0">
                    <td colspan="9">No items</td>
                </tr>
                <tr [ngStyle]="{ 'background-color': 'white' }" [hidden]="dealers.length === 0" *ngFor="let dealer of dealers">
                    <td style="padding: 6px">{{ dealer.companyName }}</td>
                    <td style="padding: 6px">{{ dealer.email }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="processing">Send Email</button>
    <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
